import { AdminSubheader } from "features/AdminSubheader";

export function OperationsManagementSubheader() {
	return <AdminSubheader items={[
		{
			label: "Summary",
			link: "/operations-management/summary"
		},
		{
			label: "Hardware tracking",
			link: "/operations-management/hardware-tracking"
		},
		{
			label: "Tagging reporting",
			link: "/operations-management/tagging-reporting"
		},
		{
			label: "Tournaments",
			link: "/operations-management/tournaments"
		},
		{
			label: "Subscription reporting",
			link: "/operations-management/subscription-reporting"
		},
	]} />
}
